import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";

import { Button, Card, CardContent, Stack, Typography } from "@components/base";

const CardContactSupport: FC = () => {
  const { t } = useTranslation();
  const { showNewMessage, isOpen } = useIntercom();

  const handleOpenChat = (): void => {
    if (isOpen) return;
    // We can customize the initial message: showNewMessage("Hi, I need help with …");
    showNewMessage();
  };

  return (
    <Card>
      <CardContent>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <div>
            <Typography variant="subtitle1" gutterBottom>
              {t("contactSupport.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("contactSupport.description")}
            </Typography>
          </div>

          <Button variant="outlined" onClick={handleOpenChat} disabled={isOpen}>
            {t("contactSupport.button")}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CardContactSupport;
